import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PRODUCTS } from "@/data/products";
import { COMPANY } from "@/data/constants";
import useQuoteSubmit from "@/hooks/useQuoteSubmit";

const initial = {
  name: "",
  email: "",
  phone: "",
  company: "",
  product: PRODUCTS[0].name,
  quantity: 100,
  message: "",
};

export const QuoteForm = ({ defaultProduct, compact = false, testIdPrefix = "qf" }) => {
  const [form, setForm] = useState({ ...initial, product: defaultProduct || initial.product });
  const { loading, submit } = useQuoteSubmit({ onSuccess: () => setForm({ ...initial }) });

  useEffect(() => {
    if (defaultProduct) {
      setForm((s) => ({ ...s, product: defaultProduct }));
    }
  }, [defaultProduct]);

  const update = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    submit(form);
  };

  return (
    <form onSubmit={handleSubmit} data-testid={`${testIdPrefix}-form`} className={`bg-white border border-[var(--mn-line)] rounded-[4px] ${compact ? "p-6" : "p-7 md:p-10"}`}>
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <label className="mn-label" htmlFor={`${testIdPrefix}-name`}>Nome*</label>
          <input
            id={`${testIdPrefix}-name`}
            type="text"
            required
            value={form.name}
            onChange={update("name")}
            placeholder="Seu nome completo"
            className="mn-input"
            data-testid={`${testIdPrefix}-name`}
          />
        </div>
        <div>
          <label className="mn-label" htmlFor={`${testIdPrefix}-company`}>Empresa</label>
          <input
            id={`${testIdPrefix}-company`}
            type="text"
            value={form.company}
            onChange={update("company")}
            placeholder="Nome da empresa"
            className="mn-input"
            data-testid={`${testIdPrefix}-company`}
          />
        </div>
        <div>
          <label className="mn-label" htmlFor={`${testIdPrefix}-email`}>E-mail*</label>
          <input
            id={`${testIdPrefix}-email`}
            type="email"
            required
            value={form.email}
            onChange={update("email")}
            placeholder="email@empresa.com.br"
            className="mn-input"
            data-testid={`${testIdPrefix}-email`}
          />
        </div>
        <div>
          <label className="mn-label" htmlFor={`${testIdPrefix}-phone`}>Telefone / WhatsApp*</label>
          <input
            id={`${testIdPrefix}-phone`}
            type="tel"
            required
            value={form.phone}
            onChange={update("phone")}
            placeholder="(11) 99999-9999"
            className="mn-input"
            data-testid={`${testIdPrefix}-phone`}
          />
        </div>
        <div>
          <label className="mn-label" htmlFor={`${testIdPrefix}-product`}>Produto*</label>
          <select
            id={`${testIdPrefix}-product`}
            value={form.product}
            onChange={update("product")}
            className="mn-input"
            data-testid={`${testIdPrefix}-product`}
          >
            {PRODUCTS.map((p) => (
              <option key={p.slug} value={p.name}>
                {p.name}
              </option>
            ))}
            <option value="Outros / Brindes Corporativos">Outros / Brindes Corporativos</option>
          </select>
        </div>
        <div>
          <label className="mn-label" htmlFor={`${testIdPrefix}-qty`}>Quantidade*</label>
          <input
            id={`${testIdPrefix}-qty`}
            type="number"
            min="50"
            required
            value={form.quantity}
            onChange={update("quantity")}
            placeholder="100"
            className="mn-input"
            data-testid={`${testIdPrefix}-quantity`}
          />
        </div>
      </div>

      <div className="mt-5">
        <label className="mn-label" htmlFor={`${testIdPrefix}-msg`}>Mensagem / Detalhes</label>
        <textarea
          id={`${testIdPrefix}-msg`}
          rows={4}
          value={form.message}
          onChange={update("message")}
          placeholder="Conte-nos sobre seu projeto, prazos e necessidades específicas..."
          className="mn-input resize-none"
          data-testid={`${testIdPrefix}-message`}
        />
      </div>

      <div className="mt-7 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
        <p className="text-xs text-[var(--mn-dark)] max-w-md leading-relaxed">
          Ao enviar, você concorda em ser contatado pela equipe da {COMPANY.full}. Seus dados são
          tratados conforme a nossa{" "}
          <Link to="/politica-de-privacidade" className="underline hover:text-[var(--mn-gold)]" target="_blank" rel="noopener noreferrer">
            Política de Privacidade
          </Link>.
        </p>
        <button
          type="submit"
          disabled={loading}
          className="btn-mn-primary !min-w-[220px] disabled:opacity-70 disabled:cursor-not-allowed"
          data-testid={`${testIdPrefix}-submit`}
        >
          {loading ? (
            <>
              <i className="fa-solid fa-circle-notch fa-spin" /> Enviando...
            </>
          ) : (
            <>
              <i className="fa-regular fa-paper-plane" /> Enviar orçamento
            </>
          )}
        </button>
      </div>
    </form>
  );
};

export default QuoteForm;
